module.exports = __webpack_public_path__ + "static/media/bg16.c00c7524.jpg";